import type { IDiscussionCommentsByAssetQuery } from "../../lib/graphql/queries/discussions/__generated__/DiscussionCommentsByAsset.generated";
import AssetDiscussionComment from "./AssetDiscussionComment";

interface IAssetDiscussionCommentsListProps {
  comments: IDiscussionCommentsByAssetQuery["discussionCommentsByAsset"]["nodes"];
}

export default function AssetDiscussionCommentsList({ comments }: IAssetDiscussionCommentsListProps) {
  return (
    <div className="space-y-8">
      {comments.map((comment) => {
        return (
          <AssetDiscussionComment
            key={comment.shortId}
            comment={comment}
            participants={comment.participants}
            replies={comment.replies}
          />
        );
      })}
    </div>
  );
}
